import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';

import { BaseService } from '../base.service';

export interface ExternalAccessResponse {
  url: string;
}

@Injectable()
export class ExternalAccessService extends BaseService {

  constructor(
    protected http: HttpClient,
    protected router: Router,
    protected cookieService: CookieService
  ) {
    super(http, router, cookieService);
  }

  createIntegrityAnalyzerAccess(): Observable<ExternalAccessResponse> {
    return this.post<ExternalAccessResponse>(
      '/external-access/integrity-analyzer',
      {},
      this.httpOptions()
    );
  }
}
